import React, { useEffect } from "react";
import { motion } from "framer-motion";

export default function RegistrarMessage({ 
  accent = "#115e32",
  pageTitle = "Registrar Message | University of Creative Technology Chittagong",
}) {
	useEffect(() => {
		document.title = pageTitle;
	}, [pageTitle]);
  return (
    <div className="relative w-full min-h-screen bg-gradient-to-b from-[#B7EAFC] via-[#F0FCFF] to-[#F0FCFF]">
      {/* Hero Section with SVG */}
      <section className="relative overflow-hidden bg-gradient-to-r from-[#B7EAFC] via-[#D6F5FE] to-[#E6FAFE]">
        {/* SVG Decorative Background */}
        <div className="absolute inset-0 flex justify-center items-center opacity-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="650"
            height="650"
            viewBox="0 0 650 650"
            fill="none"
            className="animate-spin-slow"
          >
            <circle
              cx="325"
              cy="325"
              r="280"
              stroke="#014864"
              strokeWidth="3"
              strokeDasharray="12 12"
            />
            <circle
              cx="325"
              cy="325"
              r="180"
              stroke="#2563eb"
              strokeWidth="2"
              strokeDasharray="8 8"
            />
          </svg>
        </div>

        <div className="relative container mx-auto px-6 py-20 text-center">
          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1 }}
            className="text-4xl md:text-6xl font-extrabold text-gray-800"
          >
            Message from the{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#014864] to-[#2563eb]">
              Registrar
            </span>
          </motion.h1>
        </div>
      </section>

      {/* VC Message Section */}
      <section className="relative container mx-auto px-6 py-16 grid md:grid-cols-2 gap-12 items-center">
        {/* VC Picture */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="flex justify-center"
        >
          <img
            src="/img/Salahuddin-Ahmed.jpg" // replace with actual VC image path
            alt="Founder"
            className="w-80 h-96 object-cover rounded-2xl shadow-lg border-4 border-[#014864]"
          />
        </motion.div>

        {/* VC Message */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="space-y-6 text-gray-700"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-[#014864]">
            Salahuddin Ahmed
          </h2>
          <p className="italic text-sm text-gray-500">
            Registrar<br />  
			University of Creative Technology Chittagong (UCTC)
          </p>
          <p className="leading-relaxed">
			UCTC was first approved by University Grants Commission and Bangladesh government in December 29, 2015. It started its journey with six academic programs (Mechanical Engineering, Civil Engineering, Computer Science and Engineering, BBA, MBA and English Language) and four hundred students in April, 2017 (Autumn-2017). Later on another program of Public Health was approved and started at the beginning of 2019 (Autumn 2019). At present UCTC runs with eight academic programs with total 2500 students.
		  </p>
          <p className="leading-relaxed">
            As per mission UCTC will be able to contribute towards social and economical advancement of the country through provisions of knowledge based solutions to scientific, technological, economic and social changes. The overall vision is to be world class center of excellence in technology, research, innovation and entrepreneurship for sustainable development. In view of mission and vision of UCTC, the following objectives have been set up :
		  </p>
		 <ul class="space-y-4">
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#014864] font-bold">a)</span>
			  <p class="text-gray-700 leading-relaxed">
				To establish the university for providing higher education center in the country.
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#014864] font-bold">b)</span>
			  <p class="text-gray-700 leading-relaxed">
				To implement digital Bangladesh by providing modern higher education to low economic group people involving them in development of the country.
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#014864] font-bold">c)</span>
			  <p class="text-gray-700 leading-relaxed">
				To conduct courses leading to academic degrees, diplomas and certificates in collaboration of other universities and institutes of home and abroad.
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#014864] font-bold">d)</span>
			  <p class="text-gray-700 leading-relaxed">
				To develop a center for excellence and conduct courses in such a way of learning in greater Chattogram as the society may find necessary for research advancement and discrimination of knowledge.
			  </p>
			</li>
			<li class="flex items-start gap-3 p-4 rounded-lg bg-gradient-to-r from-[#D6F5FE] to-[#E6FAFE] shadow-sm hover:shadow-md transition-all duration-300">
			  <span class="text-[#014864] font-bold">e)</span>
			  <p class="text-gray-700 leading-relaxed">
				To affiliate other local and foreign universities, research institutions and learned bodies and have joint ventures with such institutions.
			  </p>
			</li>
		  </ul>
          <p className="leading-relaxed">
            UCTC has appointed a batch of young and experienced and talented faculty members right from lecture to Professor in various academic fields for teaching and research purposes. Many faculty members have foreign degrees with a good number of research publications. Some of them are authors of text books and have been awarded national awards. It has a modern library with sufficient books and journals. Class rooms and laboratories are well-equiped and set up with modern facilities. All faculty members are committed to ensure quality education with dynamic teaching and research. A powerful and honest trust body is always alert to run the university smoothly. UCTC has been running for last two years with the challenge of maintainace peace and discipline among the students, the faculty members and administrative staff. Finally, I believe that UCTC will be the best guided private university in Bangladesh in future if all academic activities combine smoothly.
		  </p>
          
        </motion.div>
      </section>
    </div>
  );
}
